import { memo } from "react";
import { Typography } from "@mui/material";
import MCQAnswer from "./MCQAnswer";
import DescriptiveTypingAnswer from "./DescriptiveTypingAnswer";
import DescriptiveUploadPDF from "./DescriptiveUploadPDF";
import CreateFileDialog from "./CreateFileDialog";
import CreateAnswerButton from "./CreateAnswerButton";

const AnswerSection = memo(function AnswerSection({
  type,
  handleChange,
  handleTypingChange,
  selectedValue,
  selectedValueSrNo,
  options,
  isMock,
  answerScrollRef,
  editorInstanceRef,
  currentSrNo,
  uploadType,
  allowUpload,
  uploadState,
  onInlineFileSelect,
  onInlineDelete,
  onInlineView,
  onInlineRetry,
  onCreateFile,
  disabled,
  fileExtension
}) {
  if (!type) return null;

  if (type === "MCQ") {
    return (
      <MCQAnswer
        selectedValue={selectedValue}
        handleChange={handleChange}
        options={options}
        isMock={isMock}
        answerScrollRef={answerScrollRef}
      />
    );
  }

  if (type === "DESCRIPTIVE_TYPING") {
    return (
      <DescriptiveTypingAnswer
        selectedValue={selectedValue}
        selectedValueSrNo={selectedValueSrNo}
        handleTypingChange={handleTypingChange}
        editorInstanceRef={editorInstanceRef}
        currentSrNo={currentSrNo}
      />
    );
  }

  if (type === "DESCRIPTIVE_UPLOAD") {
    if (uploadType === "END_EXAM_UPLOAD") {
      return (
        <Typography
          component="p"
          sx={{
            marginTop: "10px",
            fontWeight: "bold",
            color: "grey",
            marginLeft:"4px",
            fontSize: { xs: "14px", md: "16px" },
          }}
        >
          Write your answer on paper, clearly label it, scan or photograph it, and upload it after submitting the exam. A defined time window will be provided for the upload after the exam submission.
          <CreateAnswerButton srNo={currentSrNo} disabled={disabled} fileExtension={fileExtension} />
        </Typography>
      );
    }

    if (allowUpload !== true || uploadType !== "INLINE_UPLOAD") return null;
    return (
      <>
        <DescriptiveUploadPDF
          currentSrNo={currentSrNo}
          uploadState={uploadState}
          onFileSelect={onInlineFileSelect}
          onDelete={onInlineDelete}
          onView={onInlineView}
          onRetry={onInlineRetry}
          disabled={disabled}
        />
        <CreateAnswerButton srNo={currentSrNo} disabled={disabled} fileExtension={fileExtension} />
      </>
    );
  }

  return null;
});

export default AnswerSection;